import Vue, { RenderContext } from 'vue';

export const props = {
    headerClass: {
        type: [String, Object, Array],
        default: null
    }
};

export const TCardHeader = Vue.extend({
    name: 'TCardHeader',
    functional: true,
    props,
    render(h: any, { props, children, data, slots, scopedSlots }: RenderContext) {
        return h(
            'div',
            {
                class: [props.headerClass, {}],
                staticClass: 'card-header'
            },
            children
        );
    }
});
